import RokovaniePov from './RokovaniePov';

export default RokovaniePov;
